module.exports = __webpack_public_path__ + "img/tutorial_guideChat_04.cbe85f68.jpg";